<template>
    <section class="dp-layout psychology-archive-page">
        <!-- 左侧组织架构树 -->
        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" pane-title="组织架构" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>

        <!-- 右侧档案管理主区 -->
        <section class="dp-right">
            <template v-if="hasSchoolSelected">
                <!-- 顶部检索与操作工具栏 -->
                <div class="filter-bar">
                        <el-form :inline="true" size="small" class="filter-form">
                            <el-form-item label="危机等级">
                                <el-select v-model="filterForm.attentionLevel" placeholder="全部等级" clearable style="width: 140px;" @change="handleSearch">
                                    <el-option label="一类" :value="1" />
                                    <el-option label="二类" :value="2" />
                                    <el-option label="三类" :value="3" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="心理评估">
                                <el-select v-model="filterForm.psychReviewStatus" placeholder="全部状态" clearable style="width: 140px;" @change="handleSearch">
                                    <el-option label="不适用" :value="0" />
                                    <el-option label="待评估" :value="1" />
                                    <el-option label="已评估" :value="2" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="档案状态">
                                <el-select v-model="filterForm.status" placeholder="全部状态" clearable style="width: 130px;" @change="handleSearch">
                                    <el-option label="正常在档" :value="1" />
                                    <el-option label="已结案归档" :value="2" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="关键字">
                                <el-input v-model="filterForm.keyword" placeholder="姓名或学号" clearable @keyup.enter.native="handleSearch" style="width: 160px;" />
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                                <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                            </el-form-item>
                        </el-form>

                        <div class="action-btn-group">
                            <el-button type="success" size="small" icon="el-icon-download" :loading="exporting" @click="openExportExcelDialog">
                                导出台账 Excel
                            </el-button>
                            <el-button type="primary" size="small" icon="el-icon-folder" :loading="exportingZip" @click="handleExportZip">
                                按年级/班级导出 ZIP
                            </el-button>
                        </div>
                    </div>

                    <!-- 表格主区 -->
                    <div class="tbl-scroll-host">
                        <el-table :data="tableData" v-loading="loading" border style="width: 100%;" height="100%" class="compact-table">
                        <el-table-column type="index" label="序号" width="55" align="center" />
                        <el-table-column prop="StudentName" label="学生姓名" width="120">
                            <template slot-scope="scope">
                                <span class="student-name">{{ scope.row.StudentName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="StudentNumber" label="学号" width="130">
                            <template slot-scope="scope">
                                <span>{{ scope.row.StudentNumber || scope.row.StuCode || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Gender" label="性别" width="65" align="center">
                            <template slot-scope="scope">
                                <span>{{ (scope.row.Gender === '男' || scope.row.Gender === '女') ? scope.row.Gender : '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="DepartmentName" label="所在班级" min-width="160" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.DepartmentName || scope.row.ClassName || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="CampusName" label="所属校区" min-width="150" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.CampusName && scope.row.CampusName !== '-'" size="small" type="info">{{ scope.row.CampusName }}</el-tag>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="AttentionLevel" label="危机等级" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.AttentionLevel === 3" type="danger" size="small" effect="dark">三类</el-tag>
                                <el-tag v-else-if="scope.row.AttentionLevel === 2" type="warning" size="small" effect="dark">二类</el-tag>
                                <el-tag v-else-if="scope.row.AttentionLevel === 1" type="success" size="small">一类</el-tag>
                                <span v-else class="text-muted">未评估</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="家长填写" width="90" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.ParentStatus === 1 ? 'success' : 'info'" size="mini">{{ scope.row.ParentStatus === 1 ? '已填' : '未填' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="班主任填写" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.HomeroomStatus === 1 ? 'success' : 'info'" size="mini">{{ scope.row.HomeroomStatus === 1 ? '已填' : '未填' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="心理评估" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.PsychStatus === 2" type="success" size="mini">已评估</el-tag>
                                <el-tag v-else-if="scope.row.PsychStatus === 1" type="danger" size="mini">待评估</el-tag>
                                <el-tag v-else type="info" size="mini">不适用</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Status" label="档案状态" width="115" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="Number(scope.row.Status) === 2" type="info" size="small">已结案归档</el-tag>
                                <el-tag v-else type="success" size="small">正常在档</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="TotalCounselingCount" label="咨询次数" width="90" align="center" />
                        <el-table-column prop="LastCounselingTime" label="最近咨询时间" width="160" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.LastCounselingTime || '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="200" align="center">
                            <template slot-scope="scope">
                                <div class="table-op-pair">
                                    <el-button type="text" class="table-op-link" @click="openBrowse(scope.row)">浏览</el-button>
                                    <el-button type="text" class="table-op-link" @click="openChangeLogs(scope.row)">变动记录</el-button>
                                    <el-button type="text" class="table-op-link" @click="downloadPaper(scope.row)">下载</el-button>
                                    <el-button type="text" class="table-op-link" @click="viewDetail(scope.row)">全貌</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>

                    <!-- 分页条 -->
                    <el-col :span="24" class="toolbar">
                        <el-pagination
                            background
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pageSize"
                            :total="total"
                            @size-change="handleSizeChange"
                            @current-change="handlePageChange"
                            style="float: right;"
                        />
                    </el-col>
                </template>

                <div v-else class="no-department-tip">
                    <div class="no-department-tip__inner">
                        <i class="el-icon-user"></i>
                        <p>请在左侧选择所属组织或班级，查看学生心理档案</p>
                    </div>
                </div>
            </section>

            <!-- 档案全貌查看弹窗 -->
            <el-dialog
                title="学生心理健康全貌档案"
                :visible.sync="detailDialogVisible"
                width="1060px"
                custom-class="psychology-detail-dialog"
                :close-on-click-modal="false"
                append-to-body
            >
                <div v-loading="loadingDetail" class="dialog-fixed-body" v-if="detailData">
                    <!-- 顶部学生基本信息卡片（固定在上方，不随列表滚动） -->
                    <div class="profile-card">
                        <div class="profile-main">
                            <div class="avatar-box">
                                <!-- OSS 私有桶：el-avatar 不支持 v-oss-src，改用原生 img 预签。最后修改：2026-09-14 -->
                                <img
                                    v-if="detailData.student.HeadPhotoImage || detailData.student.PhotoUrl"
                                    v-oss-src="detailData.student.HeadPhotoImage || detailData.student.PhotoUrl"
                                    class="archive-stu-avatar"
                                    alt=""
                                />
                                <el-avatar
                                    v-else
                                    :size="58"
                                    icon="el-icon-user-solid"
                                />
                            </div>
                            <div class="info-block">
                                <div class="name-line">
                                    <span class="stu-name">{{ detailData.student.Name || detailData.student.StuName || (currentArchiveRow ? currentArchiveRow.StudentName : '') }}</span>
                                    <el-tag size="mini" :type="detailData.student.Sex === '女' ? 'danger' : 'primary'">{{ detailData.student.Sex || (currentArchiveRow ? currentArchiveRow.Gender : '-') }}</el-tag>
                                    <span class="stu-dept">
                                        <i class="el-icon-office-building"></i>
                                        {{ detailData.student.DepartmentName || detailData.student.ClassName || (currentArchiveRow ? (currentArchiveRow.DepartmentName || currentArchiveRow.ClassName) : '-') }}
                                    </span>
                                    <el-tag v-if="detailData.student.CampusName || (currentArchiveRow && currentArchiveRow.CampusName)" size="mini" type="info">
                                        {{ detailData.student.CampusName || currentArchiveRow.CampusName }}
                                    </el-tag>
                                    <el-tag v-if="Number((detailData.archive && detailData.archive.Status) || (currentArchiveRow && currentArchiveRow.Status)) === 2" size="mini" type="info" effect="plain">
                                        已结案归档
                                    </el-tag>
                                    <el-tag v-else size="mini" type="success" effect="plain">
                                        正常在档
                                    </el-tag>
                                </div>
                                <div class="meta-line">
                                    <span>学号：{{ detailData.student.StudentNumber || detailData.student.StuCode || (currentArchiveRow ? (currentArchiveRow.StudentNumber || currentArchiveRow.StuCode) : '-') }}</span>
                                    <span>生日：{{ detailData.student.Birthday || '-' }}</span>
                                    <span>联系电话：{{ detailData.student.MobilePhone || detailData.student.Msisdn || '-' }}</span>
                                </div>
                                <div class="meta-line">
                                    <span>家庭住址：{{ detailData.student.Address || '-' }}</span>
                                </div>
                            </div>
                            <div class="status-block">
                                <div class="status-title">危机等级</div>
                                <el-tag v-if="detailData.archive.AttentionLevel === 3" type="danger" size="medium" effect="dark">三类</el-tag>
                                <el-tag v-else-if="detailData.archive.AttentionLevel === 2" type="warning" size="medium" effect="dark">二类</el-tag>
                                <el-tag v-else-if="detailData.archive.AttentionLevel === 1" type="success" size="medium">一类</el-tag>
                                <span v-else class="text-muted">未评估</span>
                                <div style="margin-top: 4px;">
                                    <el-tag v-if="Number(detailData.archive.Status) === 2" type="info" size="mini">已结案归档</el-tag>
                                    <el-tag v-else type="success" size="mini">正常在档</el-tag>
                                </div>
                                <div style="margin-top: 4px;">
                                    <el-button type="text" size="mini" icon="el-icon-edit" @click="openEditArchive(currentArchiveRow)">调整结档状态</el-button>
                                </div>
                            </div>
                        </div>

                        <!-- 档案备注 -->
                        <div class="archive-remark-box" v-if="detailData.archive.ArchiveRemark">
                            <i class="el-icon-chat-dot-round"></i>
                            <span>档案总评备注：{{ detailData.archive.ArchiveRemark }}</span>
                        </div>
                    </div>

                    <!-- 标签页切换区（咨询纪要、预约流水） -->
                    <el-tabs v-model="drawerTab" type="border-card" class="archive-detail-tabs" @tab-click="handleTabClick">
                        <!-- Tab 1: 历次咨询纪要 -->
                        <el-tab-pane label="咨询纪要跟踪" name="counseling">
                            <div class="tab-pane-toolbar">
                                <div class="toolbar-left">
                                    <span class="pane-title">历次咨询记录 ({{ counselingTotal }})</span>
                                    <el-input
                                        v-model="counselingKeyword"
                                        size="small"
                                        placeholder="搜索纪要内容/咨询老师/备注"
                                        prefix-icon="el-icon-search"
                                        clearable
                                        style="width: 240px;"
                                        @input="handleCounselingFilterChange"
                                        @clear="handleCounselingFilterChange"
                                    />
                                    <el-select
                                        v-model="counselingTypeFilter"
                                        size="small"
                                        placeholder="咨询来源类型"
                                        clearable
                                        style="width: 140px;"
                                        @change="handleCounselingFilterChange"
                                    >
                                        <el-option label="全部来源" value="" />
                                        <el-option label="预约关联咨询" value="appointment" />
                                        <el-option label="独立现场咨询" value="direct" />
                                    </el-select>
                                    <el-button
                                        v-if="counselingKeyword || counselingTypeFilter"
                                        type="text"
                                        size="small"
                                        icon="el-icon-refresh-left"
                                        @click="resetCounselingFilter"
                                    >
                                        重置
                                    </el-button>
                                </div>
                                <div class="toolbar-right">
                                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="openAddCounseling(currentArchiveRow)">
                                        录入新纪要
                                    </el-button>
                                </div>
                            </div>

                            <!-- 纪要流水平滑内部滑动区域 -->
                            <div v-loading="loadingCounseling" class="tab-inner-scroll-host">
                                <div v-if="counselingGroups.length > 0" class="counseling-groups">
                                    <section
                                        v-for="group in counselingGroups"
                                        :key="group.key"
                                        class="counseling-group"
                                        :class="{ 'is-selected': group.appointment && String(group.appointment.Id) === String(selectedAppointmentId) }"
                                    >
                                        <div class="group-header">
                                            <div class="group-heading">
                                                <span class="group-icon" :class="{ 'is-direct': !group.appointment }">
                                                    <i :class="group.appointment ? 'el-icon-date' : 'el-icon-chat-dot-round'"></i>
                                                </span>
                                                <div>
                                                    <div class="group-title">
                                                        {{ group.appointment ? `预约咨询 · ${formatDate(group.appointment.AppointDate)}` : '独立咨询记录' }}
                                                        <el-tag size="mini" type="info">{{ group.records.length }} 条纪要</el-tag>
                                                    </div>
                                                    <div v-if="group.appointment" class="group-meta">
                                                        <span>{{ group.appointment.TimeMode === 1 ? (group.appointment.SpecialCourseTimeName || '特殊课程时段') : `${group.appointment.StartTime || ''}${group.appointment.EndTime ? ' - ' + group.appointment.EndTime : ''}` }}</span>
                                                        <span>预约原因：{{ group.appointment.Reason || group.appointment.ConsultReason || '-' }}</span>
                                                        <span v-if="group.appointment.CheckInTime">签到：{{ group.appointment.CheckInTime }}</span>
                                                    </div>
                                                    <div v-else class="group-meta">未关联心理预约，由心理老师现场直接登记</div>
                                                </div>
                                            </div>
                                            <el-button
                                                v-if="group.appointment"
                                                type="primary"
                                                plain
                                                size="mini"
                                                icon="el-icon-plus"
                                                @click="openAddCounseling(currentArchiveRow, group.appointment)"
                                            >
                                                新增跟进
                                            </el-button>
                                        </div>

                                        <el-timeline class="group-timeline">
                                            <el-timeline-item
                                                v-for="item in group.records"
                                                :key="item.Id"
                                                :timestamp="formatRecordTime(item)"
                                                placement="top"
                                            >
                                                <el-card shadow="never" class="record-card">
                                                    <div class="record-head">
                                                        <span class="teacher-tag"><i class="el-icon-s-custom"></i> 咨询老师：{{ item.TeacherName || '-' }}</span>
                                                        <div class="record-actions">
                                                            <el-button type="text" size="mini" icon="el-icon-edit" @click="openEditCounseling(item)">编辑</el-button>
                                                            <el-button type="text" size="mini" style="color: #F56C6C;" icon="el-icon-delete" @click="handleDeleteCounseling(item)">删除</el-button>
                                                        </div>
                                                    </div>
                                                    <div class="record-content">{{ item.Content }}</div>
                                                    <div v-if="item.Attachments && item.Attachments.length > 0" class="record-attachments">
                                                        <span class="att-title">佐证附件：</span>
                                                        <psychology-attachment-viewer
                                                            :attachments="item.Attachments"
                                                            :school-id="schoolId"
                                                            layout="compact"
                                                            image-size="52px"
                                                            style="flex: 1;"
                                                        />
                                                    </div>
                                                    <div class="record-footer" v-if="item.NextFollowUpDate || item.Remark">
                                                        <span v-if="item.NextFollowUpDate" class="followup-time">
                                                            <i class="el-icon-time"></i> 下次跟进日期：{{ formatDate(item.NextFollowUpDate) }}
                                                        </span>
                                                        <span v-if="item.Remark" class="remark-text">备注：{{ item.Remark }}</span>
                                                    </div>
                                                </el-card>
                                            </el-timeline-item>
                                        </el-timeline>
                                    </section>
                                </div>
                                <div v-else-if="counselingKeyword || counselingTypeFilter" class="empty-placeholder">
                                    <i class="el-icon-search"></i>
                                    <p>未检索到符合条件的咨询纪要</p>
                                    <el-button size="mini" type="text" @click="resetCounselingFilter">清空搜索条件</el-button>
                                </div>
                                <div v-else class="empty-placeholder">
                                    <i class="el-icon-document-remove"></i>
                                    <p>暂无咨询纪要，可点击上方按钮现场录入</p>
                                </div>
                            </div>

                            <!-- 咨询纪要流水分页（固定在底部） -->
                            <div class="dialog-pagination-box">
                                <el-pagination
                                    background
                                    size="small"
                                    layout="total, sizes, prev, pager, next"
                                    :page-sizes="[3, 5, 10, 20]"
                                    :current-page="counselingPage"
                                    :page-size="counselingPageSize"
                                    :total="counselingTotal"
                                    @size-change="handleCounselingSizeChange"
                                    @current-change="handleCounselingPageChange"
                                />
                            </div>
                        </el-tab-pane>

                        <!-- Tab 2: 预约历史 -->
                        <el-tab-pane label="心理预约流水" name="appointment" lazy>
                            <div class="tab-table-host">
                                <el-table
                                    ref="appointmentTable"
                                    v-loading="loadingAppointment"
                                    :data="appointmentList"
                                    border
                                    size="small"
                                    height="100%"
                                    style="width: 100%; height: 100%;"
                                >
                                    <el-table-column prop="AppointDate" label="预约日期" min-width="110" align="center">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.AppointDate ? scope.row.AppointDate.slice(0, 10) : '-' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="TimeMode" label="时段模式" min-width="120" align="center">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.TimeMode === 1 ? '特殊课程时段' : '自选时间' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="CreatedTeacherName" label="发起班主任" min-width="120" align="center" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.ApplyTeacherName || scope.row.CreatedTeacherName || '-' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Status" label="状态" min-width="95" align="center">
                                        <template slot-scope="scope">
                                            <el-tag v-if="scope.row.Status === 0" type="warning" size="mini">待审核</el-tag>
                                            <el-tag v-else-if="scope.row.Status === 1" type="primary" size="mini">已同意</el-tag>
                                            <el-tag v-else-if="scope.row.Status === 2" type="info" size="mini">已拒绝</el-tag>
                                            <el-tag v-else-if="scope.row.Status === 3" type="success" size="mini">已签到</el-tag>
                                            <el-tag v-else type="info" size="mini">已取消</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="ConsultReason" label="预约原因" min-width="200" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.Reason || scope.row.ConsultReason || '-' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="CheckInTime" label="现场签到时间" min-width="160" align="center" />
                                    <el-table-column label="咨询纪要" min-width="105" align="center">
                                        <template slot-scope="scope">
                                            <el-tag v-if="getAppointmentCounselingCount(scope.row) > 0" type="success" size="mini">
                                                {{ getAppointmentCounselingCount(scope.row) }} 条
                                            </el-tag>
                                            <span v-else class="text-muted">暂无</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="200" align="center" fixed="right">
                                        <template slot-scope="scope">
                                            <div v-if="scope.row.Status === 3 || getAppointmentCounselingCount(scope.row) > 0" class="table-op-pair">
                                                <el-button
                                                    v-if="getAppointmentCounselingCount(scope.row) > 0"
                                                    type="text"
                                                    class="table-op-link"
                                                    @click="viewAppointmentCounseling(scope.row)"
                                                >
                                                    查看纪要
                                                </el-button>
                                                <el-button
                                                    v-if="scope.row.Status === 3"
                                                    type="text"
                                                    class="table-op-link"
                                                    @click="openAddCounseling(currentArchiveRow, scope.row)"
                                                >
                                                    {{ getAppointmentCounselingCount(scope.row) > 0 ? '新增跟进' : '录入纪要' }}
                                                </el-button>
                                            </div>
                                            <span v-else class="text-muted">—</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>

                            <!-- 预约流水分页（固定在底部） -->
                            <div class="dialog-pagination-box">
                                <el-pagination
                                    background
                                    size="small"
                                    layout="total, sizes, prev, pager, next"
                                    :page-sizes="[5, 10, 20]"
                                    :current-page="appointmentPage"
                                    :page-size="appointmentPageSize"
                                    :total="appointmentTotal"
                                    @size-change="handleAppointmentSizeChange"
                                    @current-change="handleAppointmentPageChange"
                                />
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="detailDialogVisible = false">关 闭</el-button>
                </div>
            </el-dialog>

            <!-- 浏览三角色纸表 -->
            <el-dialog
                :visible.sync="browseVisible"
                width="980px"
                append-to-body
                title=" "
                custom-class="psychology-paper-browse-dialog"
                :close-on-click-modal="false"
            >
                <div class="paper-browse-toolbar">
                    <div class="paper-browse-toolbar__title">{{ (browseStudentName || '学生') + ' · 心理档案纸表' }}</div>
                    <el-radio-group v-model="browseFormType" size="small" class="paper-browse-switch" @change="loadBrowseForm">
                        <el-radio-button label="parent">家长</el-radio-button>
                        <el-radio-button label="homeroom">班主任</el-radio-button>
                        <el-radio-button label="psych">心理老师</el-radio-button>
                    </el-radio-group>
                </div>
                <div v-loading="browseLoading" class="paper-browse-body">
                    <div v-if="browseMasked" class="empty-placeholder">
                        <p>该生心理老师表已评估，等级：{{ browseAttentionText || '已评估' }}。正文仅心理老师与后台档案权限可查看。</p>
                    </div>
                    <psychology-paper-preview v-else-if="browsePaper" :paper="browsePaper" :school-id="schoolId" />
                    <div v-else class="empty-placeholder">
                        <p>该角色表尚未填写</p>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" :disabled="!browsePaper || browseMasked" @click="downloadPaperByType(browseFormType, 'pdf')">下载 PDF</el-button>
                    <el-button size="small" :disabled="!browsePaper || browseMasked" @click="downloadPaperByType(browseFormType, 'word')">下载 Word</el-button>
                    <el-button size="small" type="primary" @click="browseVisible = false">关 闭</el-button>
                </div>
            </el-dialog>

            <!-- 变动记录：摘要卡片 + 展开明细 -->
            <el-dialog
                :title="(browseStudentName || '学生') + ' · 信息变动记录'"
                :visible.sync="changeLogVisible"
                width="720px"
                append-to-body
                custom-class="psychology-changelog-dialog"
                :close-on-click-modal="false"
                @closed="onChangeLogClosed"
            >
                <div class="clog-toolbar">
                    <el-radio-group v-model="changeLogFormType" size="small" @change="handleChangeLogFilter">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button label="parent">家长</el-radio-button>
                        <el-radio-button label="homeroom">班主任</el-radio-button>
                        <el-radio-button label="psych">心理老师</el-radio-button>
                    </el-radio-group>
                    <span class="clog-toolbar__count">共 {{ changeLogTotal }} 条</span>
                </div>

                <div v-loading="changeLogLoading" class="clog-body">
                    <div v-if="!changeLogLoading && changeLogList.length === 0" class="clog-empty">
                        <i class="el-icon-document"></i>
                        <p>暂无变动记录</p>
                    </div>

                    <div
                        v-for="(row, idx) in changeLogList"
                        :key="row.Id || row.id || idx"
                        class="clog-card"
                        :class="{ 'is-open': isChangeLogOpen(row, idx) }"
                    >
                        <button type="button" class="clog-card__head" @click="toggleChangeLog(row, idx)">
                            <div class="clog-card__left">
                                <span class="clog-card__dot" :class="'tone-' + formTypeTone(row.FormType || row.formType)"></span>
                                <div class="clog-card__meta">
                                    <div class="clog-card__line1">
                                        <el-tag size="mini" :type="formTypeTagType(row.FormType || row.formType)" effect="plain">
                                            {{ formTypeLabel(row.FormType || row.formType) }}
                                        </el-tag>
                                        <span class="clog-card__op">{{ changeLogOperatorLabel(row) }}</span>
                                        <span v-if="changeLogFillSourceLabel(row)" class="clog-card__src">{{ changeLogFillSourceLabel(row) }}</span>
                                    </div>
                                    <div class="clog-card__line2">
                                        {{ formatChangeLogTime(row.ChangeTime || row.changeTime) }}
                                        <span class="clog-card__kind">{{ changeKindLabel(row.ChangeKind || row.changeKind) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="clog-card__right">
                                <span class="clog-card__count">{{ meaningfulDiffs(row).length }} 项变更</span>
                                <i class="el-icon-arrow-right clog-card__arrow"></i>
                            </div>
                        </button>

                        <div class="clog-card__preview" v-if="!isChangeLogOpen(row, idx)">
                            <span
                                v-for="(diff, di) in previewDiffs(row)"
                                :key="'pv-' + di"
                                class="clog-chip"
                            >{{ diffDisplayLabel(diff) }}</span>
                            <span
                                v-if="meaningfulDiffs(row).length > 3"
                                class="clog-chip clog-chip--more"
                            >+{{ meaningfulDiffs(row).length - 3 }}</span>
                            <span v-if="meaningfulDiffs(row).length === 0" class="clog-chip clog-chip--muted">无业务字段变更</span>
                        </div>

                        <div class="clog-card__detail" v-show="isChangeLogOpen(row, idx)">
                            <div v-if="meaningfulDiffs(row).length === 0" class="clog-detail-empty">
                                本次仅写入系统快照，没有业务字段变更。
                            </div>
                            <div
                                v-for="(diff, di) in meaningfulDiffs(row)"
                                :key="'d-' + di"
                                class="clog-diff"
                            >
                                <div class="clog-diff__label">{{ diffDisplayLabel(diff) }}</div>
                                <div class="clog-diff__vals">
                                    <span class="clog-diff__old" :title="formatDiffVal(diff.oldValue || diff.OldValue, false)">
                                        {{ formatDiffVal(diff.oldValue || diff.OldValue) }}
                                    </span>
                                    <i class="el-icon-right clog-diff__arrow"></i>
                                    <span class="clog-diff__new" :title="formatDiffVal(diff.newValue || diff.NewValue, false)">
                                        {{ formatDiffVal(diff.newValue || diff.NewValue) }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="systemDiffs(row).length" class="clog-system">
                                <button type="button" class="clog-system__toggle" @click.stop="toggleSystemDiff(row, idx)">
                                    {{ isSystemDiffOpen(row, idx) ? '收起' : '查看' }}系统快照字段（{{ systemDiffs(row).length }}）
                                </button>
                                <div v-show="isSystemDiffOpen(row, idx)" class="clog-system__list">
                                    <div
                                        v-for="(diff, di) in systemDiffs(row)"
                                        :key="'sys-' + di"
                                        class="clog-diff clog-diff--sys"
                                    >
                                        <div class="clog-diff__label">{{ diffDisplayLabel(diff) }}</div>
                                        <div class="clog-diff__vals">
                                            <span class="clog-diff__old" :title="formatDiffVal(diff.oldValue || diff.OldValue, false)">{{ formatDiffVal(diff.oldValue || diff.OldValue) }}</span>
                                            <i class="el-icon-right clog-diff__arrow"></i>
                                            <span class="clog-diff__new" :title="formatDiffVal(diff.newValue || diff.NewValue, false)">{{ formatDiffVal(diff.newValue || diff.NewValue) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dialog-pagination-box" v-if="changeLogTotal > 0">
                    <el-pagination
                        background
                        small
                        layout="total, prev, pager, next"
                        :current-page="changeLogPage"
                        :page-size="changeLogPageSize"
                        :total="changeLogTotal"
                        @current-change="handleChangeLogPage"
                    />
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" type="primary" @click="changeLogVisible = false">关 闭</el-button>
                </div>
            </el-dialog>

            <!-- 录入/编辑咨询纪要弹窗 -->
            <el-dialog :title="counselingDialogTitle" :visible.sync="counselingDialogVisible" width="600px" :close-on-click-modal="false">
                <el-form :model="counselingForm" :rules="counselingRules" ref="counselingForm" label-width="120px">
                    <el-form-item label="咨询学生">
                        <span style="font-weight: 600;">{{ currentArchiveRow ? currentArchiveRow.StudentName : '' }}</span>
                    </el-form-item>
                    <el-form-item v-if="counselingForm.AppointmentId" label="关联预约">
                        <el-tag type="primary" effect="plain" size="small">
                            {{ formatDate(counselingForm.AppointDate) }} · {{ counselingForm.AppointmentReason || '心理预约' }}
                        </el-tag>
                    </el-form-item>
                    <el-form-item label="咨询时间" prop="CounselingDate">
                        <el-date-picker
                            v-model="counselingForm.CounselingDate"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择咨询开展时间"
                            style="width: 100%;"
                        />
                    </el-form-item>
                    <el-form-item label="本次咨询纪要" prop="Content">
                        <el-input
                            v-model="counselingForm.Content"
                            type="textarea"
                            :rows="5"
                            placeholder="请客观如实记录咨询会谈情况、学生表达内容、心理评估观察及后续辅导建议..."
                            maxlength="2000"
                            show-word-limit
                        />
                    </el-form-item>
                    <el-form-item label="建议下次跟进">
                        <el-date-picker v-model="counselingForm.NextFollowUpDate" type="date" value-format="yyyy-MM-dd" placeholder="建议下次会谈跟进日期（可选）" style="width: 100%;" />
                    </el-form-item>
                    <el-form-item label="补充备注">
                        <el-input v-model="counselingForm.Remark" placeholder="其他需要留存的跟进备忘" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="counselingDialogVisible = false">取 消</el-button>
                    <el-button type="primary" :loading="submittingCounseling" @click="submitCounselingForm">确 定</el-button>
                </div>
            </el-dialog>

            <!-- 调整结档状态弹窗 -->
            <el-dialog title="调整学生心理档案结档状态" :visible.sync="editArchiveVisible" width="500px" :close-on-click-modal="false">
                <el-form :model="archiveForm" label-width="110px">
                    <el-form-item label="学生姓名">
                        <span style="font-weight: 600;">{{ archiveForm.StudentName }}</span>
                    </el-form-item>
                    <el-form-item label="危机等级">
                        <span class="text-muted">仅心理老师表回写，此处只读</span>
                    </el-form-item>
                    <el-form-item label="档案状态">
                        <el-radio-group v-model="archiveForm.Status">
                            <el-radio :label="1">正常在档</el-radio>
                            <el-radio :label="2">已结案归档</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="总评备注">
                        <el-input v-model="archiveForm.ArchiveRemark" type="textarea" :rows="3" placeholder="例如：经过系统心理辅导情绪趋于稳定" maxlength="300" show-word-limit />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editArchiveVisible = false">取 消</el-button>
                    <el-button type="primary" :loading="submittingArchive" @click="submitArchiveForm">确 定</el-button>
                </div>
            </el-dialog>

            <!-- 导出台账 Excel：可选附加三角色填写明细 -->
            <el-dialog
                :visible.sync="exportExcelVisible"
                width="560px"
                custom-class="export-excel-dialog"
                append-to-body
                :close-on-click-modal="false"
            >
                <div slot="title" class="export-excel-head">
                    <div class="export-excel-head__icon" aria-hidden="true">
                        <i class="el-icon-document"></i>
                    </div>
                    <div class="export-excel-head__text">
                        <div class="export-excel-head__title">导出台账 Excel</div>
                        <div class="export-excel-head__sub">按需附加三角色填写明细，基础台账列始终包含</div>
                    </div>
                </div>

                <div class="export-excel-body">
                    <div class="export-excel-base">
                        <div class="export-excel-base__badge">默认导出</div>
                        <div class="export-excel-base__content">
                            <div class="export-excel-base__title">基础台账列</div>
                            <div class="export-excel-base__desc">姓名、学号、性别、班级、校区、填写状态、心理评估、危机等级、最近更新</div>
                        </div>
                        <i class="el-icon-check export-excel-base__check" aria-hidden="true"></i>
                    </div>

                    <div class="export-excel-section">
                        <div class="export-excel-section__label">附加明细（可选）</div>
                        <div class="export-excel-section__hint">勾选后以「分组标题 + 字段列」展开，不再带「家长-」前缀；人多时略慢</div>
                    </div>

                    <div class="export-excel-options" role="group" aria-label="附加明细角色">
                        <div
                            v-for="opt in exportExcelRoleOptions"
                            :key="opt.value"
                            role="button"
                            tabindex="0"
                            class="export-excel-option"
                            :class="{ 'is-active': isExportRoleSelected(opt.value) }"
                            @click="toggleExportExcelRole(opt.value)"
                            @keydown.enter.prevent="toggleExportExcelRole(opt.value)"
                            @keydown.space.prevent="toggleExportExcelRole(opt.value)"
                        >
                            <span class="export-excel-option__check" aria-hidden="true">
                                <i :class="isExportRoleSelected(opt.value) ? 'el-icon-success' : 'el-icon-circle-check'"></i>
                            </span>
                            <span class="export-excel-option__main">
                                <span class="export-excel-option__title">{{ opt.title }}</span>
                                <span class="export-excel-option__desc">{{ opt.desc }}</span>
                            </span>
                            <span class="export-excel-option__tag">{{ opt.tag }}</span>
                        </div>
                    </div>
                </div>

                <div slot="footer" class="export-excel-footer">
                    <span class="export-excel-footer__meta">
                        已选附加 {{ exportExcelRoles.length }} / 3 项
                    </span>
                    <div class="export-excel-footer__actions">
                        <el-button @click="exportExcelVisible = false">取 消</el-button>
                        <el-button type="primary" icon="el-icon-download" :loading="exporting" @click="doExportExcel">
                            开始导出
                        </el-button>
                    </div>
                </div>
            </el-dialog>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import PsychologyAttachmentViewer from '../../components/Psychology/PsychologyAttachmentViewer';
import PsychologyPaperPreview from '../../components/Psychology/PsychologyPaperPreview';
import {
    getPsychologyArchiveList,
    getPsychologyArchiveDetail,
    updatePsychologyArchive,
    savePsychologyCounselingRecord,
    deletePsychologyCounselingRecord,
    exportPsychologyArchives,
    getStudentCounselingRecords,
    getStudentAppointments,
    getPsychologyArchiveForm,
    getPsychologyArchiveChangeLogs,
    downloadPsychologyArchivePaper,
    exportPsychologyClassArchiveZip
} from '../../api/modules/psychology';
import {
    resolveActiveSchoolId,
    normalizeDeptId,
    treeNodeDeptId,
    deptIdsEqual,
} from '../../utils/deptCascaderProps';

export default {
    name: 'PsychologyArchive',
    components: { DepartmentPane, PsychologyAttachmentViewer, PsychologyPaperPreview },
    data() {
        return {
            schoolId: '',
            schoolName: '',
            departmentId: '',
            /** 左侧树当前节点 DeptOrgType，用于 ZIP 范围校验。最后更新：2026-11-02 */
            selectedOrgType: '',
            filterForm: {
                attentionLevel: null,
                psychReviewStatus: null,
                status: null,
                keyword: ''
            },
            tableData: [],
            page: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            exporting: false,
            exportingZip: false,
            exportExcelVisible: false,
            exportExcelRoles: [],
            exportExcelRoleOptions: [
                {
                    value: 'parent',
                    title: '家长填写信息',
                    desc: '家庭情况、健康与特殊情况等家长表字段',
                    tag: '家长'
                },
                {
                    value: 'homeroom',
                    title: '班主任填写信息',
                    desc: '危机筛查、评估与班主任侧补充信息',
                    tag: '班主任'
                },
                {
                    value: 'psych',
                    title: '心理老师填写信息',
                    desc: '症状、危机等级、干预方案等心理评估内容',
                    tag: '心理'
                }
            ],

            // 档案全貌弹窗
            detailDialogVisible: false,
            loadingDetail: false,
            detailData: null,
            drawerTab: 'counseling',
            currentArchiveRow: null,
            selectedAppointmentId: null,

            // 录入/编辑咨询纪要
            counselingDialogVisible: false,
            counselingDialogTitle: '',
            submittingCounseling: false,
            counselingForm: {
                Id: 0,
                ArchiveId: 0,
                SchoolId: 0,
                CampusId: 0,
                StudentId: 0,
                AppointmentId: null,
                AppointDate: '',
                AppointmentReason: '',
                CounselingDate: '',
                Content: '',
                Remark: '',
                NextFollowUpDate: ''
            },
            counselingRules: {
                CounselingDate: [{ required: true, message: '请选择咨询开展时间', trigger: 'change' }],
                Content: [{ required: true, message: '请输入咨询纪要内容', trigger: 'blur' }]
            },

            // 修改档案等级与总评
            editArchiveVisible: false,
            submittingArchive: false,
            archiveForm: {
                Id: 0,
                StudentName: '',
                Status: 1,
                ArchiveRemark: ''
            },

            browseVisible: false,
            browseLoading: false,
            browseFormType: 'parent',
            browsePaper: null,
            browseMasked: false,
            browseAttentionText: '',
            browseStudentId: 0,
            browseStudentName: '',

            changeLogVisible: false,
            changeLogLoading: false,
            changeLogFormType: '',
            changeLogList: [],
            changeLogPage: 1,
            changeLogPageSize: 5,
            changeLogTotal: 0,
            changeLogExpanded: {},
            changeLogSystemExpanded: {},

            // 弹窗各子模块服务端分页与搜索状态
            counselingList: [],
            counselingTotal: 0,
            counselingPage: 1,
            counselingPageSize: 5,
            counselingKeyword: '',
            counselingTypeFilter: '',
            loadingCounseling: false,

            appointmentList: [],
            appointmentTotal: 0,
            appointmentPage: 1,
            appointmentPageSize: 10,
            loadingAppointment: false
        };
    },
    computed: {
        /** 是否已选择学校（字符串 Id，避免雪花精度丢失）。最后修改：2026-10-18 */
        hasSchoolSelected() {
            return !!normalizeDeptId(this.schoolId);
        },
        /**
         * 将当前页咨询纪要流水按预约流水分组；未关联预约的纪要归入独立咨询记录。
         */
        counselingGroups() {
            const records = this.counselingList || [];
            if (records.length === 0) return [];

            const groupMap = new Map();
            const directRecords = [];

            records.forEach(record => {
                if (!record.AppointmentId) {
                    directRecords.push(record);
                    return;
                }

                const key = String(record.AppointmentId);
                if (!groupMap.has(key)) {
                    groupMap.set(key, {
                        key: `appointment-${key}`,
                        appointment: record.Appointment || {
                            Id: record.AppointmentId,
                            AppointDate: record.CounselingDate,
                            Reason: '历史预约'
                        },
                        records: []
                    });
                }
                groupMap.get(key).records.push(record);
            });

            const groups = Array.from(groupMap.values());
            groups.forEach(group => {
                group.records.sort((a, b) => {
                    const timeA = a.CounselingDate || a.CreateTime || '';
                    const timeB = b.CounselingDate || b.CreateTime || '';
                    return String(timeB).localeCompare(String(timeA)) || (Number(b.Id) - Number(a.Id));
                });
            });
            groups.sort((a, b) => String(b.appointment.AppointDate || '').localeCompare(String(a.appointment.AppointDate || '')));

            if (this.selectedAppointmentId) {
                const selectedKey = String(this.selectedAppointmentId);
                groups.sort((a, b) => {
                    const aSelected = String(a.appointment.Id) === selectedKey ? 1 : 0;
                    const bSelected = String(b.appointment.Id) === selectedKey ? 1 : 0;
                    return bSelected - aSelected;
                });
            }

            if (directRecords.length > 0) {
                groups.push({
                    key: 'direct',
                    appointment: null,
                    records: directRecords
                });
            }

            return groups;
        }
    },
    watch: {
        '$store.state.activeSchoolId'(newSchoolId) {
            const id = normalizeDeptId(newSchoolId);
            if (id && !deptIdsEqual(id, this.schoolId)) {
                this.schoolId = id;
                this.departmentId = '';
                this.selectedOrgType = 'school';
                this.page = 1;
                this.loadTableData();
            }
        }
    },
    methods: {
        resolveSchoolId() {
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return fromStore;
            return normalizeDeptId(this.schoolId);
        },

        treeNodeClick(data, node) {
            if (!data) return;
            const orgType = String((data.DeptOrgType || data.deptOrgType) || '').toLowerCase();
            const activeSchoolId = this.resolveSchoolId();
            const isSchoolNode = orgType === 'school' || orgType === 'affiliateschool'
                || (!orgType && (Number(data.type) === 1 || deptIdsEqual(data.value, activeSchoolId)));

            if (isSchoolNode) {
                this.schoolId = treeNodeDeptId(data) || activeSchoolId;
                this.schoolName = data.label || '';
                this.departmentId = '';
                this.selectedOrgType = orgType || 'school';
            } else {
                this.departmentId = treeNodeDeptId(data);
                this.schoolName = data.label || this.schoolName;
                this.selectedOrgType = orgType || this.inferOrgTypeFromLabel(data.label);
                let tempNode = node;
                let foundSchoolId = '';
                while (tempNode) {
                    const pType = String((tempNode.data && (tempNode.data.DeptOrgType || tempNode.data.deptOrgType)) || '').toLowerCase();
                    if (tempNode.data && (pType === 'school' || pType === 'affiliateschool')) {
                        foundSchoolId = treeNodeDeptId(tempNode.data);
                        break;
                    }
                    tempNode = tempNode.parent;
                }
                this.schoolId = foundSchoolId || activeSchoolId || normalizeDeptId(this.schoolId);
            }
            this.page = 1;
            this.loadTableData();
        },

        /** 无 DeptOrgType 时按名称粗判年级/班级。最后更新：2026-11-02 */
        inferOrgTypeFromLabel(label) {
            const name = String(label || '');
            if (name.includes('班')) return 'class';
            if (name.includes('级')) return 'grade';
            return '';
        },

        /** ZIP 仅允许年级或班级。最后更新：2026-11-02 */
        isZipScopeAllowed() {
            if (!this.departmentId) return false;
            const t = String(this.selectedOrgType || '').toLowerCase();
            if (t === 'grade' || t === 'class') return true;
            if (!t) return this.inferOrgTypeFromLabel(this.schoolName) === 'grade'
                || this.inferOrgTypeFromLabel(this.schoolName) === 'class';
            return false;
        },

        formatDate(value) {
            return value ? String(value).slice(0, 10) : '-';
        },

        getNowDateTimeString() {
            const d = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },

        formatRecordTime(item) {
            if (!item) return '-';
            const cTime = item.CounselingDate ? String(item.CounselingDate).replace('T', ' ') : '';
            const createTime = item.CreateTime ? String(item.CreateTime).replace('T', ' ') : '';

            // 1. 若 CounselingDate 具有有效时分秒且不是 00:00:00，优先展示（时分：yyyy-MM-dd HH:mm）
            if (cTime && cTime.length >= 16 && !cTime.includes('00:00:00')) {
                return cTime.slice(0, 16);
            }
            // 2. 若 CounselingDate 只有日期（或者 00:00:00），提取 CreateTime 的具体时间点补充呈现
            if (createTime && createTime.length >= 16) {
                const datePart = cTime ? cTime.slice(0, 10) : createTime.slice(0, 10);
                const timePart = createTime.slice(11, 16);
                return `${datePart} ${timePart}`;
            }
            if (cTime) {
                return cTime.slice(0, 16);
            }
            return '-';
        },

        getAppointmentCounselingCount(appointment) {
            if (!appointment) return 0;
            if (appointment.CounselingRecords && Array.isArray(appointment.CounselingRecords)) {
                return appointment.CounselingRecords.length;
            }
            if (this.counselingList && this.counselingList.length > 0) {
                return this.counselingList.filter(
                    item => item.AppointmentId && String(item.AppointmentId) === String(appointment.Id)
                ).length;
            }
            return 0;
        },

        viewAppointmentCounseling(appointment) {
            this.selectedAppointmentId = appointment.Id;
            this.counselingKeyword = '';
            this.counselingTypeFilter = '';
            this.counselingPage = 1;
            this.drawerTab = 'counseling';
            this.fetchStudentCounselingRecords();
        },

        async loadTableData() {
            if (!this.schoolId) return;
            this.loading = true;
            try {
                const params = {
                    page: this.page,
                    intPageSize: this.pageSize,
                    schoolId: this.schoolId,
                    departmentId: this.departmentId || 0,
                    attentionLevel: this.filterForm.attentionLevel || null,
                    psychReviewStatus: this.filterForm.psychReviewStatus,
                    status: this.filterForm.status || null,
                    keyword: this.filterForm.keyword || ''
                };
                const res = await getPsychologyArchiveList(params);
                if (res.data && res.data.success) {
                    const resp = res.data.response;
                    this.tableData = resp.data || [];
                    this.total = resp.dataCount || 0;
                } else {
                    this.tableData = [];
                    this.total = 0;
                }
            } catch (err) {
                this.$message.error('加载学生心理档案列表失败');
            } finally {
                this.loading = false;
            }
        },

        handleSearch() {
            this.page = 1;
            this.loadTableData();
        },

        handleReset() {
            this.filterForm.attentionLevel = null;
            this.filterForm.psychReviewStatus = null;
            this.filterForm.status = null;
            this.filterForm.keyword = '';
            this.page = 1;
            this.loadTableData();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.page = 1;
            this.loadTableData();
        },

        handlePageChange(val) {
            this.page = val;
            this.loadTableData();
        },

        openExportExcelDialog() {
            if (!this.schoolId) {
                this.$message.warning('请先在左侧选择学校或部门');
                return;
            }
            this.exportExcelVisible = true;
        },

        isExportRoleSelected(role) {
            return (this.exportExcelRoles || []).indexOf(role) >= 0;
        },

        toggleExportExcelRole(role) {
            const list = this.exportExcelRoles ? this.exportExcelRoles.slice() : [];
            const idx = list.indexOf(role);
            if (idx >= 0) list.splice(idx, 1);
            else list.push(role);
            this.exportExcelRoles = list;
        },

        async doExportExcel() {
            if (!this.schoolId) return;
            this.exporting = true;
            try {
                const roles = this.exportExcelRoles || [];
                const params = {
                    schoolId: this.schoolId,
                    departmentId: this.departmentId || 0,
                    attentionLevel: this.filterForm.attentionLevel || null,
                    keyword: this.filterForm.keyword || '',
                    includeParent: roles.indexOf('parent') >= 0,
                    includeHomeroom: roles.indexOf('homeroom') >= 0,
                    includePsych: roles.indexOf('psych') >= 0
                };
                const res = await exportPsychologyArchives(params);
                const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `学生心理档案_${new Date().toISOString().slice(0, 10)}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.exportExcelVisible = false;
                this.$message.success('档案数据导出成功');
            } catch (err) {
                if (!(err && err.bizMessage)) {
                    this.$message.error('导出 Excel 失败');
                }
            } finally {
                this.exporting = false;
            }
        },

        // ================= 全貌档案弹窗 =================

        async viewDetail(row) {
            this.currentArchiveRow = row;
            this.detailDialogVisible = true;
            this.loadingDetail = true;
            this.drawerTab = 'counseling';
            this.selectedAppointmentId = null;
            this.detailData = null;

            // 重置 3 个 Tab 的服务端分页参数与数据列表
            this.counselingPage = 1;
            this.counselingKeyword = '';
            this.counselingTypeFilter = '';
            this.counselingList = [];
            this.counselingTotal = 0;

            this.appointmentPage = 1;
            this.appointmentList = [];
            this.appointmentTotal = 0;

            try {
                const res = await getPsychologyArchiveDetail({ id: row.ArchiveId || row.Id });
                if (res.data && res.data.success) {
                    const resp = res.data.response || {};
                    const student = resp.Student || resp.student || {};
                    const archive = resp.Archive || resp.archive || {};

                    this.detailData = {
                        student,
                        archive
                    };

                    this.fetchStudentCounselingRecords();
                } else {
                    this.$message.error(res.data ? res.data.msg : '加载详情失败');
                }
            } catch (err) {
                this.$message.error('加载全貌档案异常');
            } finally {
                this.loadingDetail = false;
            }
        },

        async fetchStudentCounselingRecords() {
            const studentId = (this.detailData && this.detailData.student && this.detailData.student.Id) || (this.currentArchiveRow && this.currentArchiveRow.StudentId) || 0;
            const archiveId = (this.detailData && this.detailData.archive && this.detailData.archive.Id)
                || (this.currentArchiveRow && (this.currentArchiveRow.ArchiveId || this.currentArchiveRow.Id))
                || 0;
            if (!studentId && !archiveId) return;

            this.loadingCounseling = true;
            try {
                const params = {
                    archiveId,
                    studentId,
                    page: this.counselingPage,
                    intPageSize: this.counselingPageSize,
                    keyword: this.counselingKeyword || '',
                    sourceType: this.counselingTypeFilter || ''
                };
                const res = await getStudentCounselingRecords(params);
                if (res.data && res.data.success) {
                    const pageData = res.data.response || {};
                    this.counselingList = pageData.data || [];
                    this.counselingTotal = pageData.dataCount || 0;
                } else {
                    this.counselingList = [];
                    this.counselingTotal = 0;
                }
            } catch (err) {
                this.$message.error('加载咨询纪要失败');
            } finally {
                this.loadingCounseling = false;
            }
        },

        async fetchStudentAppointments() {
            const studentId = (this.detailData && this.detailData.student && this.detailData.student.Id) || (this.currentArchiveRow && this.currentArchiveRow.StudentId) || 0;
            if (!studentId) return;

            this.loadingAppointment = true;
            try {
                const params = {
                    studentId,
                    page: this.appointmentPage,
                    intPageSize: this.appointmentPageSize
                };
                const res = await getStudentAppointments(params);
                if (res.data && res.data.success) {
                    const pageData = res.data.response || {};
                    this.appointmentList = pageData.data || [];
                    this.appointmentTotal = pageData.dataCount || 0;
                } else {
                    this.appointmentList = [];
                    this.appointmentTotal = 0;
                }
            } catch (err) {
                this.$message.error('加载心理预约流水失败');
            } finally {
                this.loadingAppointment = false;
                this.$nextTick(() => {
                    if (this.$refs.appointmentTable) this.$refs.appointmentTable.doLayout();
                });
            }
        },

        formTypeLabel(type) {
            const map = { parent: '家长', homeroom: '班主任', psych: '心理老师' };
            return map[type] || type || '-';
        },

        formTypeTagType(type) {
            if (type === 'parent') return 'success';
            if (type === 'homeroom') return 'warning';
            if (type === 'psych') return '';
            return 'info';
        },

        formTypeTone(type) {
            if (type === 'parent') return 'parent';
            if (type === 'homeroom') return 'homeroom';
            if (type === 'psych') return 'psych';
            return 'default';
        },

        fillSourceLabel(source) {
            const map = {
                parentSelf: '家长本人',
                parent: '家长本人',
                homeroom: '班主任填写',
                psych: '心理老师填写',
                homeroomProxy: '班主任代录'
            };
            return map[source] || '';
        },

        changeLogFillSourceLabel(row) {
            const named = (row && (row.FillSourceName || row.fillSourceName) || '').trim();
            if (named) return named;
            return this.fillSourceLabel(row && (row.FillSource || row.fillSource));
        },

        /** 变动记录操作人展示名（家长自填常无姓名，勿回退成英文源码） */
        changeLogOperatorLabel(row) {
            const name = (row && (row.OperatorName || row.operatorName) || '').trim();
            if (name && name !== 'parentSelf' && name !== 'homeroomProxy') return name;
            const type = (row && (row.FormType || row.formType)) || '';
            if (type === 'parent') return '家长';
            if (type === 'homeroom') return '班主任';
            if (type === 'psych') return '心理老师';
            return '系统';
        },

        changeKindLabel(kind) {
            const map = { create: '首次填写', update: '修改', resign: '重签' };
            return map[kind] || (kind ? String(kind) : '变更');
        },

        formatChangeLogTime(value) {
            if (!value) return '-';
            return String(value).replace('T', ' ').slice(0, 19);
        },

        changeLogKey(row, idx) {
            return String(row.Id || row.id || idx);
        },

        isChangeLogOpen(row, idx) {
            return !!this.changeLogExpanded[this.changeLogKey(row, idx)];
        },

        isSystemDiffOpen(row, idx) {
            return !!this.changeLogSystemExpanded[this.changeLogKey(row, idx)];
        },

        toggleChangeLog(row, idx) {
            const key = this.changeLogKey(row, idx);
            this.$set(this.changeLogExpanded, key, !this.changeLogExpanded[key]);
        },

        toggleSystemDiff(row, idx) {
            const key = this.changeLogKey(row, idx);
            this.$set(this.changeLogSystemExpanded, key, !this.changeLogSystemExpanded[key]);
        },

        handleChangeLogFilter() {
            this.changeLogPage = 1;
            this.changeLogExpanded = {};
            this.changeLogSystemExpanded = {};
            this.fetchChangeLogs();
        },

        parseDiff(row) {
            const raw = row.Diff || row.DiffJson || row.diffJson || [];
            if (Array.isArray(raw)) return raw;
            if (typeof raw === 'string') {
                try { return JSON.parse(raw) || []; } catch (e) { return []; }
            }
            return [];
        },

        /** 系统自动写入的快照字段，默认折叠不打扰阅读。创建于 2026-09-19 */
        isSystemDiffField(diff) {
            const fieldKey = String((diff && (diff.fieldKey || diff.FieldKey)) || '').toLowerCase();
            const label = String((diff && (diff.label || diff.Label)) || '');
            const systemKeys = [
                'formtype', 'campusname', 'schoolname', 'classname', 'classteacher',
                'gender', 'stucode', 'studentnumber', 'birthday', 'hometown', 'ethnicity',
                'idcard', 'interests', 'address', 'studentname',
                'level1guide', 'level2guide', 'level3guide', 'guideversion'
            ];
            if (fieldKey && systemKeys.indexOf(fieldKey) >= 0) return true;
            const systemLabels = [
                '姓名', '性别', '学号', '出生年月', '班级', '校区', '学校', '班主任',
                '籍贯', '民族', '身份证', '兴趣爱好', '家庭住址', '住址', '表类型'
            ];
            return systemLabels.indexOf(label) >= 0;
        },

        onChangeLogClosed() {
            this.changeLogExpanded = {};
            this.changeLogSystemExpanded = {};
        },

        meaningfulDiffs(row) {
            return this.parseDiff(row).filter(d => !this.isSystemDiffField(d));
        },

        systemDiffs(row) {
            return this.parseDiff(row).filter(d => this.isSystemDiffField(d));
        },

        previewDiffs(row) {
            return this.meaningfulDiffs(row).slice(0, 3);
        },

        diffDisplayLabel(diff) {
            return (diff && (diff.label || diff.Label || diff.fieldKey || diff.FieldKey)) || '字段';
        },

        /**
         * 变动记录新旧值展示：字符串 / 选项码数组 / 家庭成员等对象数组均可读。
         * @param {*} val 原始值
         * @param {boolean} [truncate=true] 是否截断过长文本（title 传 false 看全文）
         * 最后更新：2026-09-24
         */
        formatDiffVal(val, truncate) {
            const doTruncate = truncate !== false;
            if (val == null || val === '') return '空';
            if (typeof val === 'string') {
                const t = val.trim();
                if (!t || t === '[]' || t === '{}' || t === 'null') return '空';
                // 尝试解析 JSON 数组/对象，避免 ["4"] 或 [{...}] 生硬展示
                if ((t.startsWith('[') && t.endsWith(']')) || (t.startsWith('{') && t.endsWith('}'))) {
                    try {
                        const parsed = JSON.parse(t);
                        return this.formatDiffVal(parsed, truncate);
                    } catch (e) {
                        return doTruncate ? this.truncateDiffText(t) : t;
                    }
                }
                return doTruncate ? this.truncateDiffText(t) : t;
            }
            if (Array.isArray(val)) {
                if (!val.length) return '空';
                // 对象行（家庭成员/学习经历/重大生活事件）用「；」分隔多行；标量仍用「、」
                const hasObject = val.some(v => v != null && typeof v === 'object' && !Array.isArray(v));
                const parts = val.map(v => this.formatDiffVal(v, false)).filter(s => s && s !== '空');
                if (!parts.length) return '空';
                const joined = parts.join(hasObject ? '；' : '、');
                return doTruncate ? this.truncateDiffText(joined) : joined;
            }
            if (typeof val === 'object') {
                const parts = Object.keys(val).map(k => {
                    const v = val[k];
                    if (v == null || v === '') return '';
                    if (typeof v === 'object') return this.formatDiffVal(v, false);
                    return String(v).trim();
                }).filter(Boolean);
                if (!parts.length) return '空';
                const joined = parts.join(' / ');
                return doTruncate ? this.truncateDiffText(joined) : joined;
            }
            return String(val);
        },

        /** 变动值过长时截断，完整内容靠 title 悬浮查看 */
        truncateDiffText(text) {
            const s = text == null ? '' : String(text);
            return s.length > 120 ? s.slice(0, 120) + '…' : s;
        },

        async openBrowse(row) {
            this.browseStudentId = row.StudentId;
            this.browseStudentName = row.StudentName;
            this.browseFormType = 'parent';
            this.browseVisible = true;
            await this.loadBrowseForm();
        },

        async loadBrowseForm() {
            if (!this.browseStudentId) return;
            this.browseLoading = true;
            this.browsePaper = null;
            this.browseMasked = false;
            try {
                const res = await getPsychologyArchiveForm({ studentId: this.browseStudentId, formType: this.browseFormType });
                if (res.data && res.data.success) {
                    const data = res.data.response || {};
                    this.browseMasked = !!data.Masked;
                    this.browseAttentionText = data.AttentionLevelText || '';
                    this.browsePaper = data.Paper || data.paper || null;
                } else {
                    this.$message.error((res.data && res.data.msg) || '加载纸表失败');
                }
            } catch (e) {
                this.$message.error('加载纸表失败');
            } finally {
                this.browseLoading = false;
            }
        },

        async openChangeLogs(row) {
            this.browseStudentId = row.StudentId;
            this.browseStudentName = row.StudentName;
            this.changeLogFormType = '';
            this.changeLogPage = 1;
            this.changeLogExpanded = {};
            this.changeLogSystemExpanded = {};
            this.changeLogVisible = true;
            await this.fetchChangeLogs();
        },

        async fetchChangeLogs() {
            if (!this.browseStudentId) return;
            this.changeLogLoading = true;
            try {
                const res = await getPsychologyArchiveChangeLogs({
                    studentId: this.browseStudentId,
                    formType: this.changeLogFormType || '',
                    page: this.changeLogPage,
                    intPageSize: this.changeLogPageSize
                });
                if (res.data && res.data.success) {
                    const pageData = res.data.response || {};
                    this.changeLogList = pageData.data || pageData.Data || [];
                    this.changeLogTotal = pageData.dataCount || pageData.DataCount || 0;
                } else {
                    this.changeLogList = [];
                    this.changeLogTotal = 0;
                }
            } catch (e) {
                this.$message.error('加载变动记录失败');
            } finally {
                this.changeLogLoading = false;
            }
        },

        handleChangeLogPage(val) {
            this.changeLogPage = val;
            this.changeLogExpanded = {};
            this.changeLogSystemExpanded = {};
            this.fetchChangeLogs();
        },

        async downloadPaper(row) {
            this.browseStudentId = row.StudentId;
            this.browseStudentName = row.StudentName;
            try {
                await this.$confirm('请选择下载格式', '下载档案', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: 'PDF',
                    cancelButtonText: 'Word'
                });
                await this.savePaperBlob(row.StudentId, '', 'pdf', `${row.StudentName || '学生'}-心理档案.pdf`);
            } catch (action) {
                if (action === 'cancel') {
                    await this.savePaperBlob(row.StudentId, '', 'word', `${row.StudentName || '学生'}-心理档案.docx`);
                }
            }
        },

        async downloadPaperByType(formType, format) {
            if (!this.browseStudentId) return;
            if (!this.browsePaper || this.browseMasked) {
                this.$message.warning('该角色表尚未填写，无法下载');
                return;
            }
            const ext = format === 'word' ? 'docx' : 'pdf';
            await this.savePaperBlob(this.browseStudentId, formType, format, `${this.browseStudentName || '学生'}-${this.formTypeLabel(formType)}.${ext}`);
        },

        async handleExportZip() {
            if (!this.schoolId) {
                this.$message.warning('请先在左侧选择学校');
                return;
            }
            if (!this.isZipScopeAllowed()) {
                this.$message.warning('ZIP 仅支持按年级或班级导出，请先在左侧选中年级/班级（不支持整校）');
                return;
            }
            if (!this.total) {
                this.$message.warning('当前范围没有学生，无法导出');
                return;
            }

            // 先选格式；禁止点遮罩误关。最后更新：2026-11-02
            let format = 'pdf';
            try {
                await this.$confirm(
                    `请选择 ZIP 内纸表格式。当前约 ${this.total} 名学生，已填表越多打包越久，请耐心等待。`,
                    '按年级/班级导出 ZIP',
                    {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '导出 PDF',
                        cancelButtonText: '导出 Word',
                        closeOnClickModal: false,
                        type: 'info'
                    }
                );
            } catch (action) {
                if (action === 'cancel') format = 'word';
                else return;
            }

            this.exportingZip = true;
            const loading = this.$loading({
                lock: true,
                text: `正在打包约 ${this.total} 名学生的纸表，请勿关闭页面…`,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.35)'
            });
            try {
                const res = await exportPsychologyClassArchiveZip({
                    schoolId: this.schoolId,
                    departmentId: this.departmentId || 0,
                    format
                });
                this.triggerBlobDownload(res, `心理档案_${format}_${new Date().toISOString().slice(0, 10)}.zip`);
                this.$message.success('ZIP 导出成功');
            } catch (e) {
                if (!(e && e.bizMessage)) {
                    this.$message.error((e && e.message) || '导出 ZIP 失败');
                }
            } finally {
                loading.close();
                this.exportingZip = false;
            }
        },

        async savePaperBlob(studentId, formType, format, fileName) {
            try {
                const res = await downloadPsychologyArchivePaper({ studentId, formType: formType || '', format });
                this.triggerBlobDownload(res, fileName);
            } catch (e) {
                this.$message.error('下载失败，可能该表尚未填写');
            }
        },

        triggerBlobDownload(res, fileName) {
            const blob = new Blob([res.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        },

        // ================= 咨询纪要管理 =================

        handleAppointmentSizeChange(val) {
            this.appointmentPageSize = val;
            this.appointmentPage = 1;
            this.fetchStudentAppointments();
        },

        handleAppointmentPageChange(val) {
            this.appointmentPage = val;
            this.fetchStudentAppointments();
        },

        handleCounselingFilterChange() {
            this.counselingPage = 1;
            this.fetchStudentCounselingRecords();
        },

        resetCounselingFilter() {
            this.counselingKeyword = '';
            this.counselingTypeFilter = '';
            this.counselingPage = 1;
            this.fetchStudentCounselingRecords();
        },

        handleCounselingSizeChange(val) {
            this.counselingPageSize = val;
            this.counselingPage = 1;
            this.fetchStudentCounselingRecords();
        },

        handleCounselingPageChange(val) {
            this.counselingPage = val;
            this.fetchStudentCounselingRecords();
        },

        // ================= 咨询纪要管理 =================

        openAddCounseling(row, appointment = null) {
            const targetRow = row || this.currentArchiveRow;
            if (!targetRow) return;
            this.currentArchiveRow = targetRow;
            this.counselingDialogTitle = appointment ? '录入预约咨询纪要' : '录入独立咨询纪要';
            this.counselingForm = {
                Id: 0,
                ArchiveId: targetRow.ArchiveId || targetRow.Id,
                SchoolId: this.schoolId,
                CampusId: targetRow.CampusId || 0,
                StudentId: targetRow.StudentId,
                AppointmentId: appointment ? appointment.Id : null,
                AppointDate: appointment ? appointment.AppointDate : '',
                AppointmentReason: appointment ? (appointment.Reason || appointment.ConsultReason || '') : '',
                CounselingDate: this.getNowDateTimeString(),
                Content: '',
                Remark: '',
                NextFollowUpDate: ''
            };
            this.counselingDialogVisible = true;
            this.$nextTick(() => this.$refs.counselingForm && this.$refs.counselingForm.clearValidate());
        },

        openEditCounseling(item) {
            const appointment = item.AppointmentId && this.detailData
                ? (this.detailData.appointments || []).find(row => String(row.Id) === String(item.AppointmentId))
                : null;
            this.counselingDialogTitle = '编辑心理咨询纪要';
            this.counselingForm = {
                Id: item.Id,
                ArchiveId: item.ArchiveId,
                SchoolId: this.schoolId,
                CampusId: item.CampusId || 0,
                StudentId: item.StudentId,
                AppointmentId: item.AppointmentId || null,
                AppointDate: appointment ? appointment.AppointDate : '',
                AppointmentReason: appointment ? (appointment.Reason || appointment.ConsultReason || '') : '',
                CounselingDate: item.CounselingDate
                    ? String(item.CounselingDate).replace('T', ' ').slice(0, 19)
                    : (item.CreateTime ? String(item.CreateTime).replace('T', ' ').slice(0, 19) : this.getNowDateTimeString()),
                Content: item.Content,
                Remark: item.Remark || '',
                NextFollowUpDate: item.NextFollowUpDate || ''
            };
            this.counselingDialogVisible = true;
            this.$nextTick(() => this.$refs.counselingForm && this.$refs.counselingForm.clearValidate());
        },

        submitCounselingForm() {
            this.$refs.counselingForm.validate(async (valid) => {
                if (!valid) return;
                this.submittingCounseling = true;
                try {
                    const res = await savePsychologyCounselingRecord(this.counselingForm);
                    if (res.data && res.data.success) {
                        this.$message.success('咨询纪要已保存');
                        this.counselingDialogVisible = false;
                        if (this.detailDialogVisible && this.currentArchiveRow) {
                            this.viewDetail(this.currentArchiveRow);
                        }
                        this.loadTableData();
                    } else {
                        this.$message.error(res.data ? res.data.msg : '保存失败');
                    }
                } catch (err) {
                    this.$message.error('保存纪要失败');
                } finally {
                    this.submittingCounseling = false;
                }
            });
        },

        handleDeleteCounseling(item) {
            this.$confirm('确定要删除本条咨询纪要吗？', '删除提示', { type: 'warning' })
                .then(async () => {
                    const res = await deletePsychologyCounselingRecord({ id: item.Id });
                    if (res.data && res.data.success) {
                        this.$message.success('纪要已删除');
                        if (this.detailDialogVisible && this.currentArchiveRow) {
                            this.viewDetail(this.currentArchiveRow);
                        }
                        this.loadTableData();
                    } else {
                        this.$message.error(res.data ? res.data.msg : '删除失败');
                    }
                }).catch(() => {});
        },

        // ================= 修改档案评级 =================

        openEditArchive(row) {
            this.archiveForm = {
                Id: row.ArchiveId || row.Id,
                StudentName: row.StudentName,
                Status: row.Status || 1,
                ArchiveRemark: row.ArchiveRemark || ''
            };
            this.editArchiveVisible = true;
        },

        async submitArchiveForm() {
            this.submittingArchive = true;
            try {
                const res = await updatePsychologyArchive({
                    id: this.archiveForm.Id,
                    archiveRemark: this.archiveForm.ArchiveRemark,
                    status: this.archiveForm.Status
                });
                if (res.data && res.data.success) {
                    this.$message.success('档案状态已更新');
                    this.editArchiveVisible = false;
                    this.loadTableData();
                    if (this.detailDialogVisible && this.currentArchiveRow) {
                        this.viewDetail(this.currentArchiveRow);
                    }
                } else {
                    this.$message.error(res.data ? res.data.msg : '更新失败');
                }
            } catch (err) {
                this.$message.error('更新档案总评失败');
            } finally {
                this.submittingArchive = false;
            }
        }
    },
    mounted() {
        const defaultSchoolId = this.resolveSchoolId();
        if (defaultSchoolId) {
            this.schoolId = defaultSchoolId;
        }
        // 列表由左侧教学树首次点击加载，避免与 DepartmentPane 初始化重复请求
    }
};
</script>

<style scoped>
.filter-bar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 8px;
    flex-shrink: 0;
}

.filter-form .el-form-item {
    margin-bottom: 6px;
}

.toolbar {
    margin-top: 8px;
    padding: 0;
    flex-shrink: 0;
}

.student-name {
    font-weight: 600;
    color: #303133;
}

.paper-browse-body {
    min-height: 420px;
    max-height: 64vh;
    overflow: auto;
    padding: 12px 10px 16px;
    background: #e5e7eb;
    border: 1px solid #d1d5db;
    border-radius: 4px;
}

.clog-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.clog-toolbar__count {
    font-size: 12px;
    color: #94a3b8;
}

.clog-body {
    min-height: 220px;
    max-height: 58vh;
    overflow: auto;
    padding: 2px 2px 8px;
}

.clog-empty {
    text-align: center;
    padding: 48px 12px;
    color: #94a3b8;
}

.clog-empty i {
    font-size: 32px;
    margin-bottom: 8px;
}

.clog-card {
    background: #fff;
    border: 1px solid #e8edf3;
    border-radius: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.clog-card:hover {
    border-color: #cbd5e1;
}

.clog-card.is-open {
    border-color: #93c5fd;
    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.08);
}

.clog-card__head {
    width: 100%;
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    cursor: pointer;
    text-align: left;
}

.clog-card__left {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    min-width: 0;
}

.clog-card__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-top: 7px;
    background: #94a3b8;
    flex-shrink: 0;
}

.clog-card__dot.tone-parent { background: #16a34a; }
.clog-card__dot.tone-homeroom { background: #ea580c; }
.clog-card__dot.tone-psych { background: #2563eb; }

.clog-card__meta {
    min-width: 0;
}

.clog-card__line1 {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.clog-card__op {
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
}

.clog-card__src {
    font-size: 12px;
    color: #94a3b8;
}

.clog-card__line2 {
    margin-top: 4px;
    font-size: 12px;
    color: #64748b;
    display: flex;
    align-items: center;
    gap: 8px;
}

.clog-card__kind {
    color: #94a3b8;
}

.clog-card__right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.clog-card__count {
    font-size: 12px;
    color: #64748b;
    background: #f1f5f9;
    border-radius: 999px;
    padding: 2px 8px;
}

.clog-card__arrow {
    color: #94a3b8;
    transition: transform 0.2s;
}

.clog-card.is-open .clog-card__arrow {
    transform: rotate(90deg);
    color: #2563eb;
}

.clog-card__preview {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0 14px 12px 32px;
}

.clog-chip {
    display: inline-flex;
    align-items: center;
    max-width: 160px;
    height: 22px;
    padding: 0 8px;
    border-radius: 6px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    color: #475569;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.clog-chip--more {
    background: #eff6ff;
    border-color: #bfdbfe;
    color: #2563eb;
}

.clog-chip--muted {
    color: #94a3b8;
}

.clog-card__detail {
    border-top: 1px solid #eef2f7;
    background: #f8fafc;
    padding: 10px 14px 12px;
}

.clog-detail-empty {
    font-size: 12px;
    color: #94a3b8;
    padding: 8px 0;
}

.clog-diff {
    display: grid;
    grid-template-columns: minmax(96px, 28%) 1fr;
    gap: 10px;
    padding: 8px 10px;
    margin-bottom: 6px;
    background: #fff;
    border: 1px solid #e8edf3;
    border-radius: 8px;
}

.clog-diff--sys {
    opacity: 0.85;
}

.clog-diff__label {
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    line-height: 1.5;
    padding-top: 2px;
}

.clog-diff__vals {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    min-width: 0;
}

.clog-diff__old,
.clog-diff__new {
    flex: 1;
    min-width: 0;
    font-size: 12px;
    line-height: 1.5;
    padding: 4px 8px;
    border-radius: 6px;
    word-break: break-word;
}

.clog-diff__old {
    background: #fef2f2;
    color: #b91c1c;
    text-decoration: line-through;
    text-decoration-color: rgba(185, 28, 28, 0.35);
}

.clog-diff__new {
    background: #ecfdf5;
    color: #047857;
    font-weight: 500;
}

.clog-diff__arrow {
    color: #94a3b8;
    margin-top: 6px;
    flex-shrink: 0;
}

.clog-system {
    margin-top: 8px;
}

.clog-system__toggle {
    border: 0;
    background: transparent;
    color: #64748b;
    font-size: 12px;
    cursor: pointer;
    padding: 4px 0;
}

.clog-system__toggle:hover {
    color: #2563eb;
}

.clog-system__list {
    margin-top: 6px;
}

.tag-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.badge-pill {
    color: #fff;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 500;
    display: inline-block;
}

.text-muted {
    color: #c0c4cc;
}

.pagination-bar {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}

/* 档案全貌弹窗样式已由下方非 scoped 样式统一定制 */

.profile-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 18px;
}

.profile-main {
    display: flex;
    align-items: center;
}

.avatar-box {
    margin-right: 18px;
}

.archive-stu-avatar {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    object-fit: cover;
    display: block;
    background: #f1f5f9;
}

.info-block {
    flex: 1;
}

.name-line {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}

.stu-name {
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
}

.stu-dept {
    font-size: 14px;
    color: #64748b;
    margin-left: 8px;
}

.meta-line {
    font-size: 13px;
    color: #475569;
    display: flex;
    gap: 16px;
    margin-top: 4px;
}

.status-block {
    text-align: center;
    padding-left: 20px;
    border-left: 1px dashed #cbd5e1;
}

.status-title {
    font-size: 12px;
    color: #94a3b8;
    margin-bottom: 6px;
}

.tag-row {
    margin-top: 14px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.tag-row-label {
    font-size: 13px;
    color: #64748b;
}

.archive-remark-box {
    margin-top: 12px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 13px;
    color: #334155;
    line-height: 1.5;
}

.archive-remark-box i {
    color: #409EFF;
    margin-right: 6px;
}

.tab-pane-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 14px;
}

.tab-pane-toolbar .toolbar-left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.tab-pane-toolbar .toolbar-right {
    display: flex;
    align-items: center;
}

.tab-pane-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
}

.pane-title {
    font-size: 14px;
    font-weight: 600;
    color: #334155;
}

.timeline-box {
    padding: 10px 4px;
}

.counseling-groups {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 2px;
}

.counseling-group {
    overflow: hidden;
    background: #fff;
    border: 1px solid #dfe7f1;
    border-radius: 8px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.counseling-group.is-selected {
    border-color: #409EFF;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.12);
}

.group-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 14px;
    background: #f6f9fd;
    border-bottom: 1px solid #e7edf5;
}

.group-heading {
    display: flex;
    align-items: flex-start;
    min-width: 0;
}

.group-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    margin-right: 10px;
    color: #fff;
    background: #409EFF;
    border-radius: 7px;
    flex-shrink: 0;
}

.group-icon.is-direct {
    background: #7b8da4;
}

.group-title {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #27364a;
    font-size: 14px;
    font-weight: 600;
}

.group-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 5px 14px;
    margin-top: 5px;
    color: #718096;
    font-size: 12px;
    line-height: 1.5;
}

.group-timeline {
    padding: 16px 16px 0 20px;
}

.record-card {
    border: 1px solid #e2e8f0;
    border-radius: 6px;
}

.record-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.teacher-tag {
    font-size: 13px;
    font-weight: 500;
    color: #409EFF;
}

.record-content {
    font-size: 14px;
    color: #334155;
    line-height: 1.6;
    white-space: pre-wrap;
}

.record-attachments {
    margin-top: 10px;
    display: flex;
    align-items: flex-start;
}

.record-attachments .att-title {
    font-size: 12px;
    color: #94a3b8;
    margin-right: 8px;
    margin-top: 6px;
    flex-shrink: 0;
}

.psychology-detail-dialog ::v-deep .el-image-viewer__wrapper,
.record-card ::v-deep .el-image-viewer__wrapper {
    z-index: 3000 !important;
}

.file-link-item {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    margin-right: 8px;
    padding: 3px 8px;
    background: #f4f4f5;
    border-radius: 4px;
    border: 1px solid #e9e9eb;
}

.record-footer {
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px dashed #e2e8f0;
    font-size: 12px;
    color: #64748b;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.followup-time {
    color: #E6A23C;
}

.empty-placeholder {
    text-align: center;
    padding: 40px 0;
    color: #94a3b8;
}

.empty-placeholder i {
    font-size: 40px;
    margin-bottom: 8px;
}

.no-department-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-height: 200px;
    color: #909399;
}

.no-department-tip i {
    font-size: 48px;
    margin-bottom: 12px;
    color: #c0c4cc;
}

.dialog-pagination-box {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
}
</style>

<style>
/* =============================================================================
 * 心理健康档案全貌弹窗布局规范（杜绝外层双滑动条，内部独立滑动）
 * ============================================================================= */
.psychology-detail-dialog {
    border-radius: 12px !important;
    overflow: hidden !important;
    height: 88vh !important;
    max-height: 88vh !important;
    display: flex !important;
    flex-direction: column !important;
    margin-top: 4vh !important;
    margin-bottom: 4vh !important;
}

.psychology-detail-dialog .el-dialog__header {
    flex-shrink: 0 !important;
    padding: 14px 20px 12px !important;
    background: #ffffff !important;
    border-bottom: 1px solid #e8edf3 !important;
}

.psychology-detail-dialog .el-dialog__body {
    flex: 1 !important;
    min-height: 0 !important;
    overflow: hidden !important; /* 彻底去除最外层双滑动条！ */
    max-height: none !important;
    padding: 14px 20px 8px !important;
    display: flex !important;
    flex-direction: column !important;
    background: #f8fafc !important;
    box-sizing: border-box !important;
}

.psychology-detail-dialog .el-dialog__footer {
    flex-shrink: 0 !important;
    padding: 10px 20px 12px !important;
    background: #ffffff !important;
    border-top: 1px solid #e8edf3 !important;
}

/* 弹窗内容整体容器：固定不滚动 */
.psychology-detail-dialog .dialog-fixed-body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* 顶部学生名片：固定置顶 */
.psychology-detail-dialog .profile-card {
    flex-shrink: 0;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* 核心 Tab 标签页容器 */
.psychology-detail-dialog .archive-detail-tabs {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
}

.psychology-detail-dialog .archive-detail-tabs .el-tabs__header {
    flex-shrink: 0;
    margin: 0;
    background: #f1f5f9;
}

.psychology-detail-dialog .archive-detail-tabs .el-tabs__content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 12px 14px 8px;
    overflow: hidden;
}

.psychology-detail-dialog .archive-detail-tabs .el-tab-pane {
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* Tab 1 纪要跟踪内部滑动宿主 */
.psychology-detail-dialog .tab-inner-scroll-host {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 6px;
}

.psychology-detail-dialog .tab-inner-scroll-host::-webkit-scrollbar {
    width: 6px;
}

.psychology-detail-dialog .tab-inner-scroll-host::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

.psychology-detail-dialog .tab-inner-scroll-host::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}

/* Tab 2 & 3 表格自适应容器 */
.psychology-detail-dialog .tab-table-host {
    flex: 1;
    min-height: 0;
    position: relative;
}

.psychology-detail-dialog .dialog-pagination-box {
    flex-shrink: 0;
    margin-top: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.psychology-paper-browse-dialog.el-dialog .el-dialog__header {
    padding: 0 !important;
    border: none !important;
}

.psychology-paper-browse-dialog.el-dialog .el-dialog__title {
    display: none !important;
}

.psychology-paper-browse-dialog.el-dialog .el-dialog__headerbtn {
    top: 14px !important;
    right: 16px !important;
    z-index: 2;
}

.psychology-paper-browse-dialog.el-dialog .el-dialog__body {
    padding: 14px 20px 10px !important;
}

.psychology-paper-browse-dialog.el-dialog .el-dialog__footer {
    padding: 8px 20px 14px !important;
}

.psychology-paper-browse-dialog .paper-browse-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-right: 28px;
    margin-bottom: 10px;
}

.psychology-paper-browse-dialog .paper-browse-toolbar__title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    line-height: 1.3;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.psychology-paper-browse-dialog .paper-browse-switch .el-radio-button__inner {
    padding: 7px 14px;
}

.psychology-changelog-dialog {
    border-radius: 12px;
    overflow: hidden;
}

.psychology-changelog-dialog .el-dialog__header {
    padding: 16px 20px 10px;
    border-bottom: 1px solid #eef2f7;
}

.psychology-changelog-dialog .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #0f172a;
}

.psychology-changelog-dialog .el-dialog__body {
    padding: 14px 20px 8px;
    background: #f8fafc;
}

.psychology-changelog-dialog .el-dialog__footer {
    padding: 10px 20px 16px;
    border-top: 1px solid #eef2f7;
    background: #fff;
}

.psychology-changelog-dialog .dialog-pagination-box {
    margin-top: 8px;
    display: flex;
    justify-content: flex-end;
}
</style>

<!-- append-to-body：弹窗挂到 body，卡片样式必须写非 scoped 才能生效 -->
<style>
.export-excel-dialog.el-dialog {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
}

.export-excel-dialog .el-dialog__header {
    padding: 18px 20px 14px;
    border-bottom: 1px solid #e8edf3;
    background: #fff;
}

.export-excel-dialog .el-dialog__headerbtn {
    top: 18px;
    right: 16px;
}

.export-excel-dialog .el-dialog__body {
    padding: 16px 20px 8px;
    background: #fff;
}

.export-excel-dialog .el-dialog__footer {
    padding: 12px 20px 16px;
    border-top: 1px solid #eef2f7;
    background: #fff;
}

.export-excel-dialog .export-excel-head {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding-right: 28px;
}

.export-excel-dialog .export-excel-head__icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: linear-gradient(145deg, #eff6ff 0%, #dbeafe 100%);
    color: #2563eb;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 20px;
}

.export-excel-dialog .export-excel-head__title {
    font-size: 16px;
    font-weight: 600;
    color: #0f172a;
    line-height: 1.35;
}

.export-excel-dialog .export-excel-head__sub {
    margin-top: 4px;
    font-size: 12px;
    color: #64748b;
    line-height: 1.45;
}

.export-excel-dialog .export-excel-body {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.export-excel-dialog .export-excel-base {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    box-sizing: border-box;
}

.export-excel-dialog .export-excel-base__badge {
    flex-shrink: 0;
    margin-top: 2px;
    padding: 2px 8px;
    border-radius: 999px;
    background: #ecfdf5;
    color: #047857;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.5;
}

.export-excel-dialog .export-excel-base__title {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
}

.export-excel-dialog .export-excel-base__desc {
    margin-top: 4px;
    font-size: 12px;
    color: #64748b;
    line-height: 1.5;
}

.export-excel-dialog .export-excel-base__check {
    margin-left: auto;
    color: #10b981;
    font-size: 18px;
    flex-shrink: 0;
}

.export-excel-dialog .export-excel-section__label {
    font-size: 13px;
    font-weight: 600;
    color: #334155;
}

.export-excel-dialog .export-excel-section__hint {
    margin-top: 4px;
    font-size: 12px;
    color: #94a3b8;
}

.export-excel-dialog .export-excel-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.export-excel-dialog .export-excel-option {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #fff;
    text-align: left;
    cursor: pointer;
    user-select: none;
    transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
}

.export-excel-dialog .export-excel-option:hover {
    border-color: #93c5fd;
    background: #f8fbff;
}

.export-excel-dialog .export-excel-option:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.18);
}

.export-excel-dialog .export-excel-option.is-active {
    border-color: #3b82f6;
    background: #eff6ff;
    box-shadow: 0 0 0 1px #3b82f6 inset;
}

.export-excel-dialog .export-excel-option__check {
    flex-shrink: 0;
    margin-top: 1px;
    font-size: 18px;
    color: #cbd5e1;
    line-height: 1;
}

.export-excel-dialog .export-excel-option.is-active .export-excel-option__check {
    color: #2563eb;
}

.export-excel-dialog .export-excel-option__main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.export-excel-dialog .export-excel-option__title {
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
}

.export-excel-dialog .export-excel-option__desc {
    font-size: 12px;
    color: #64748b;
    line-height: 1.45;
}

.export-excel-dialog .export-excel-option__tag {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 6px;
    background: #f1f5f9;
    color: #475569;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.5;
}

.export-excel-dialog .export-excel-option.is-active .export-excel-option__tag {
    background: #dbeafe;
    color: #1d4ed8;
}

.export-excel-dialog .export-excel-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
}

.export-excel-dialog .export-excel-footer__meta {
    font-size: 12px;
    color: #94a3b8;
}

.export-excel-dialog .export-excel-footer__actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

@media (prefers-reduced-motion: reduce) {
    .export-excel-dialog .export-excel-option {
        transition: none;
    }
}
</style>
